import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { SolicitacaoComprasDTO, SolicitacaoComprasInputDto } from '../classes/SolicitacaoComprasDto';

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoCompraService {

  private readonly apiPath = `${environment.apiURL}/SolicitacaoCompras`;

  constructor(private http: HttpClient) { }

  getSolicitacoes(): Observable<SolicitacaoComprasDTO[]> {
    return this.http.get<SolicitacaoComprasDTO[]>(this.apiPath);
  }

  getSolicitacoesByTipo(isPlaneda: boolean): Observable<SolicitacaoComprasDTO[]> {
    return this.http.get<SolicitacaoComprasDTO[]>(`${this.apiPath}/tipo/${isPlaneda}`);
  }

  getSolicitacaoById(id: number): Observable<SolicitacaoComprasDTO> {
    return this.http.get<SolicitacaoComprasDTO>(`${this.apiPath}/${id}`);
  }

  postSolicitacao(solicitacao: SolicitacaoComprasInputDto): Observable<any> {
    return this.http.post(this.apiPath, solicitacao);
  }

  putSolicitacao(id: number, solicitacao: SolicitacaoComprasInputDto): Observable<any> {
    return this.http.put(`${this.apiPath}/${id}`, solicitacao);
  }

  deleteSolicitacao(id: number): Observable<any> {
    return this.http.delete(`${this.apiPath}/${id}`);
  }

  gerarItens(solicitacao: SolicitacaoComprasInputDto): Observable<any[]> {
    return this.http.post<any[]>(`${this.apiPath}/gerar-itens`, solicitacao);
  }

  cancelarSolicitacoes(ids: number[]): Observable<any> {
    return this.http.put(`${this.apiPath}/cancelar`, ids);
  }


}
